import React, { useState, useEffect } from 'react';
import ICarrierData from '../../types/Carriers';
import './Partners.scss';
import { useAuth } from 'react-oidc-context';
import CarrierService from '../../services/CarrierService';

const Partners: React.FC = () => {
  const auth = useAuth();
  const [partners, setPartners] = useState<ICarrierData[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const token = auth.user?.access_token;
        const response = await CarrierService.getAll(token);
        setPartners(response.data);
      } catch (error) {
        console.error('Error fetching partners:', error);
        setError('Failed to load Carriers');
      } finally {
        setIsLoading(false);
      }
    };
    fetchPartners();
  }, [auth]);

  return (
    <div className="partners">
      <div className="partners__container">
        {isLoading ? (
          <div
            className="partners__loading"
            role="status"
            aria-live="polite"
          >
            Loading Carriers...
          </div>
        ) : error ? (
          <div
            className="partners__error"
            role="alert"
            aria-live="assertive"
          >
            {error}
          </div>
        ) : (
          <div className="partners__table-wrapper">
            <table className="partners__table" role="grid" aria-label="Partner Airlines">
              <thead>
                <tr>
                  <th scope="col">CARRIER CODE</th>
                  <th scope="col">PARTNER NAME</th>
                </tr>
              </thead>
              <tbody>
                {partners.map((partner) => (
                  <tr key={partner.carrierId}>
                    <td>{partner.carrierCode}</td>
                    <td>{partner.carrierName}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Partners;